import { DataProxy } from '@apollo/client/cache';
import { DocumentNode } from 'graphql';

interface UpdateCachePayload<T, K> {
  query: DocumentNode;
  variables: { [key: string]: any };
  reducer: (cachedData: { [key: string]: T } | null, data: K) => { [key: string]: T };
}
/**
 * `updateCache` should be used following any mutations that require updating local Apollo cache values
 */
export const updateCache = <T, K = any>(
  queries: UpdateCachePayload<T, K>[] | UpdateCachePayload<T, K>
) => (cache: DataProxy, { data }: { data: K }): void => {
  if (!Array.isArray(queries)) {
    queries = [queries];
  }

  queries.forEach(({ query, variables, reducer }) => {
    try {
      const cachedData: { [key: string]: T } | null = cache.readQuery({
        query,
        variables
      });

      if (cachedData) {
        const writeData = reducer(cachedData, data);

        cache.writeQuery({
          query,
          variables,
          data: writeData
        });
      }
    } catch (err) {
      /**
       * Do nothing for now?
       * Catching an `invariantViolation` can be expected if the query that is being updated has not been called yet.
       */
    }
  });
};
